import { useEffect, useRef } from 'react';
import { ProjectConfig } from '../types';
import { URLManager } from '../lib/url/URLManager';

interface UseModalCloseProps {
  onClose: () => void;
  project?: { identifier: string; config: ProjectConfig };
  view?: string;
  onSave?: () => Promise<void>;
}

export const useModalClose = ({ onClose, project, view }: UseModalCloseProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const urlManager = useRef(URLManager.getInstance());

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        // Find all station cards and trigger their form submissions
        const stationCards = ref.current.querySelectorAll('.station-card');
        stationCards.forEach(card => {
          const form = card.querySelector('form');
          if (form) {
            // Create and dispatch a submit event
            const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
            form.dispatchEvent(submitEvent);
          }
        });

        // Update URL to remove view parameter
        if (project && view) {
          urlManager.current.updateURL(
            project.identifier,
            'network',
            null,
            'auto',
            'menu_close'
          );
        }
        onClose();
      }
    };

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        // Find all station cards and trigger their form submissions
        if (ref.current) {
          const stationCards = ref.current.querySelectorAll('.station-card');
          stationCards.forEach(card => {
            const form = card.querySelector('form');
            if (form) {
              // Create and dispatch a submit event
              const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
              form.dispatchEvent(submitEvent);
            }
          });
        }

        // Update URL to remove view parameter
        if (project && view) {
          urlManager.current.updateURL(
            project.identifier,
            'network',
            null,
            'auto',
            'menu_close'
          );
        }
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose, project, view]);

  return ref;
}; 